// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline-module--headline--vG1cD"};